import styled from '@emotion/styled';

export const TagImage = styled.img`
  flex: 0 0 auto;
  width: auto;
  height: 14px;
`;

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  @supports not (gap: 2px) {
    ${TagImage} {
      margin-right: 2px;
    }

    ${TagImage}:last-of-type {
      margin-right: 0;
    }
  }
`;
